export default __webpack_public_path__ + "static/media/user_robert.bb0aed5a.png";